import { Path } from '@/main/router/routerPath';

import { AccountReceivable } from './AccountReceivable';

export const router = new Path('Accounting').addChildren([
	AccountReceivable.router,
]);
